import {Component, HostBinding, Input, OnInit} from '@angular/core';
import {DomSanitizer, SafeStyle} from '@angular/platform-browser';

@Component({
  selector: 'awair-device-marker-icon',
  templateUrl: './device-marker-icon.component.html',
  styleUrls: ['./device-marker-icon.component.scss']
})
export class DeviceMarkerIconComponent implements OnInit {

  @HostBinding('style.backgroundImage') hostBackgroundImage: SafeStyle = this.sanitizer.bypassSecurityTrustStyle(
    'radial-gradient(#CDD3D8 0%, rgba(255, 255, 255, 0) 70%)'
  );

  get color() {
    return this._color;
  }

  @Input()
  set color(value: string) {
    this._color = value;
    this.hostBackgroundImage = this.sanitizer.bypassSecurityTrustStyle(`radial-gradient(${value} 0%, rgba(255, 255, 255, 0) 70%)`);
  }
  // Offline color
  private _color: string = '#CDD3D8';

  constructor(private sanitizer: DomSanitizer) {
  }

  ngOnInit() {
  }
}
